import React from 'react';
import classNames from 'classnames';
import './index.scss';

const PageBanner = (pageBanner) => {
  const {
    backgroundImage, size, color, primaryLink, title, titleSubText
  } = pageBanner;
  const pageBannerClasses = classNames({
    'ma__page-banner': true,
    [`ma__page-banner--${size}`]: size,
    [`ma__page-banner--${color}`]: color,
    'ma__page-banner--linked': primaryLink
  });

  return(
    <section className={pageBannerClasses} style={{ backgroundImage: `url("${backgroundImage}")` }}>
      <div className="ma__page-banner__container">
        <div className="ma__page-banner__content" property="mainEntityOfPage">
          <div className="ma__page-banner__content-wrapper">
            <h1 className="ma__page-banner__title">
              { title }
              { titleSubText && (
              <abbr title={title}>
                { titleSubText }
              </abbr>
              )}
            </h1>
            { pageBanner.children }
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageBanner;
